import React, { useRef } from "react";
import PropTypes from "prop-types";
import { DownloadTableExcel } from "react-export-table-to-excel";
import "./excel.css";

const CollectionsSummaryPDF = ({ data = [], title = "" }) => {
  const tableRef = useRef(null);

  const renderDataWithStyle = (data) => {
    return data.map((node, index) => (
      <React.Fragment key={index}>
        {node.level !== 0 && (
          <tr>
            <td style={{ fontWeight: node.children?.length ? "bold" : "normal" }}>
              {!node.children?.length ? node.head : node.head.replace(/0+$/, "")}
            </td>
            <td style={{ fontWeight: node.children?.length ? "bold" : "normal" }}>
              {node.description}
            </td>
            <td style={{ fontWeight: node.children?.length ? "bold" : "normal" }}>
              {node.level}
            </td>
          </tr>
        )}
        {node.children && renderDataWithStyle(node.children)}
      </React.Fragment>
    ));
  };

  const flattenedData = data.flat(Infinity);

  return (
    <div>
      <DownloadTableExcel
        filename={title || "Account chart"}
        sheet={title || "Sheet1"}
        currentTableRef={tableRef.current}
      >
        <button className="export-excel-button">Export to Excel</button>
      </DownloadTableExcel>
      <table ref={tableRef} style={{ display: "none" }}>
        <thead>
          <tr>
            <th>Code</th>
            <th>Description</th>
            <th>Level</th>
          </tr>
        </thead>
        <tbody>{renderDataWithStyle(flattenedData)}</tbody>
      </table>
    </div>
  );
};

CollectionsSummaryPDF.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
};

export default CollectionsSummaryPDF;
